module.exports = require('./helpers/bundle-url').getBundleURL('HeG8V') + "logo-dark.eefe0b7f.svg";